// extracted by mini-css-extract-plugin
export default {"cta":"uca","grey":"vca","dark":"wca","chip":"xca","card":"yca","nonclickable":"zca","top":"Aca","left":"Bca","span":"Cca","name":"Eca"};
    if(module.hot) {
      // 1738836199141
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  